module.exports = __webpack_public_path__ + "img/coin_quarter.ea6d3792.svg";